import mapIcons from './map-icons.js';

var map;

var dataCache = {};
var featureListCache = {};
var featureListCacheMapObjects = {};

var markers = {};
var featureList = {};
var currentLocationMarker = null;

var translations = {
    'ledige plasser': 'free spots',
    'Få veibeskrivelse': 'Get directions',
    'Mer info': 'More info',
    'Les mer': 'Read more',
    'Du er i': 'You are in',
    'Nærmeste parkeringshus er': 'Closest parking house is'
};

var typeIcons = {
    'hcplasser': 'hc_icon.svg'
}

var location = null;
var searchFilter = "";
var searchTimeout = null;

var liveDataNameConversion = {
    'St. Olav': 'St Olav',
    'P-Siddis': 'Siddis',
    'P-Forum': 'Forum',
    'P-Kyrre': 'Kyrre',
    'P-Arketten': 'Parketten'
}

var locationDataNameConversion = {
    'P-Arketten': 'P-Arketten',
    'Domkirkehallen': 'P-Domkirkehallen',
    'P-Forum': 'P-Forum',
    'Jernbanen': 'P-Jernbanen',
    'Jorenholmen': 'P-Jorenholmen',
    'P-Kyrre': 'P-Kyrre',
    'Posten': 'P-Posten',
    'P-Siddis': 'P-Siddis',
    'St. Olav': 'P-St. Olav',
    'Valberget': 'P-Valberghallen'

}

var areaColors = {
    'Sone 1': 'rgba(215,118,105,0.7)',
    'Sone 2': 'rgba(215,118,105,0.7)',
    'Sone 3': 'rgba(227,218,165,0.7)',
    'Sone 4': 'rgba(227,218,165,0.7)',
    'Sone 5': 'rgba(227,218,165,0.7)',
    'Sone 6': 'rgba(227,218,165,0.7)',
    'Sone 7': 'rgba(107,142,57,0.7)',
    'Sone 8': 'rgba(107,142,57,0.7)',
    'Sone 9': 'rgba(227,218,165,0.7)',
    'Sone 10': 'rgba(107,142,57,0.7)',
    'Sone 11': 'rgba(107,142,57,0.7)',
    'Sone 12': 'rgba(107,142,57,0.7)',
    'Sone 13': 'rgba(107,142,57,0.7)',
    'Sone 14': 'rgba(107,142,57,0.7)',
    'Sone 15': 'rgba(107,142,57,0.7)',
    'Sone 16': 'rgba(107,142,57,0.7)',
    'Sone 17': 'rgba(107,142,57,0.7)',
    'Sone 18': 'rgba(107,142,57,0.7)',
    'Sone 19': 'rgba(215,118,105,0.7)',
    'Sone 20': 'rgba(107,142,57,0.7)',
    'Sone 21': 'rgba(107,142,57,0.7)',
    'Sone 22': 'rgba(107,142,57,0.7)',
    'Sone 23': 'rgba(107,142,57,0.7)',
    'Sone 24': 'rgba(107,142,57,0.7)',
    'Sone 25': 'rgba(107,142,57,0.7)',
    'Sandvigå': 'rgba(215,118,105,0.7)',
    'Verven': 'rgba(215,118,105,0.7)'
};

var legendSearchMemory = {};

var infowindow;
var stavangerCoords = {lat: 58.970558, lng: 5.730233};
var defaultZoom = 15;

var isMapEmbed = $('body').hasClass('map-embed');

let language = window.location.pathname.includes('/en/') ? 'en' : 'no';


export function initMap() {
    var mapElement = document.getElementById('map');

    if (!mapElement) {
        return;
    }

    if (!google.maps.Polygon.prototype.getBounds) {
        google.maps.Polygon.prototype.getBounds = function () {
            var bounds = new google.maps.LatLngBounds();
            this.getPath().forEach(function (element, index) {
                bounds.extend(element);
            });
            return bounds;
        }
    }

    var options = {
        zoom: defaultZoom,
        center: stavangerCoords,
        scrollwheel: false,
        zoomControl: isMapEmbed,
        fullscreenControl: isMapEmbed,
        mapTypeControl: isMapEmbed
    };

    map = new google.maps.Map(mapElement, options);

    setupInfoWindow();
    removeStyles();

    loadCache();
}

function setup() {
    addClickOnCheckboxes('map-phus', 'phus');
    addClickOnCheckboxes('map-ladepunkter-phus', 'el-phus');
    addClickOnCheckboxes('map-ladepunkter-gate', 'el-gateplan');
    addClickOnCheckboxes('map-pautomater', 'pautomater');
    addClickOnCheckboxes('map-hc', 'hc');
    addClickOnCheckboxes('map-mc', 'mc');
    addClickOnCheckboxes('map-sykkel', 'Sykkelparkering');
    addClickOnCheckboxes('map-buss', 'buss');
    addClickOnCheckboxes('map-bobil', 'bobil');
    setupBoligSoner();
    setupPiggdekkAvgift();
    setupZoneColors();

    var mapQueryParameter = getQueryParameter('kart');
    if (mapQueryParameter) {
        $('#map-' + mapQueryParameter).trigger('click');
    } else {
        $('#map-phus').prop('checked', true).trigger('change');
    }

    setupMapMode();
    setupSearch();
    getLocation();
    showLocationInfo();
}

function loadCache() {
    let locationPath = window.location.protocol + "//" + window.location.host + '/wp-content/themes/grensesnitt/cache/location.json?ver=2';
    let sone1_9Path = window.location.protocol + "//" + window.location.host + '/wp-content/themes/grensesnitt/cache/sone1-9.geojson';
    let sone10_25Path = window.location.protocol + "//" + window.location.host + '/wp-content/themes/grensesnitt/cache/sone10-25.geojson';
    let stavangerPath = window.location.protocol + "//" + window.location.host + '/wp-content/themes/grensesnitt/cache/stavanger.geojson';

    $.when(
        $.getJSON(locationPath),
        $.getJSON(sone1_9Path),
        $.getJSON(sone10_25Path),
        $.getJSON(stavangerPath)
    ).done(function (locationData,
                     sone1_9Data,
                     sone10_25Data,
                     stavangerData) {
        dataCache = locationData[0];

        featureListCache = {};
        featureListCache['stavanger'] = [];
        featureListCache['boligsoner'] = [];
        featureListCache['boligsoner'].push(sone1_9Data[0]);
        featureListCache['boligsoner'].push(sone10_25Data[0]);
        featureListCache['stavanger'].push(stavangerData[0]);

        //featureListCacheMapObjects['stavanger'] = [];
        //featureListCacheMapObjects['stavanger'].push(map.data.addGeoJson(featureListCache['stavanger'][0]));

        setup();
    });
}

function setupSearch() {
    $('#map-search').keyup(function () {
        clearTimeout(searchTimeout);
        var self = $(this);
        searchTimeout = setTimeout(function () {
            searchFilter = self.val().toUpperCase();
            if (searchFilter !== '') {
                if (Object.keys(legendSearchMemory).length === 0) {
                    saveLegend();
                    reActivateAllLegend();
                } else {
                    reActivateAllActiveLegend();
                }
            } else {
                if (Object.keys(legendSearchMemory).length > 0) {
                    loadLegend();
                }
            }
            doZoomIncludeAll();
        }, 500);
    });


    function reActivateAllActiveLegend() {
        $('#map-legend-options input:checkbox').each(function () {
            if ($(this).is(':checked')) {
                $(this).trigger('click');
                $(this).trigger('click');
            }
        })
    }

    function reActivateAllLegend() {
        $('#map-legend-options input:checkbox').each(function () {
            if ($(this).is(':checked')) {
                $(this).trigger('click');
            }
            $(this).trigger('click');
        })
    }

    function saveLegend() {
        legendSearchMemory = {};
        $('#map-legend-options input:checkbox').each(function () {
            legendSearchMemory[$(this).attr('id')] = $(this).is(':checked');
        })
    }

    function loadLegend() {
        // Turn everything off
        $('#map-legend-options input:checkbox').each(function () {
            if ($(this).is(':checked')) {
                $(this).trigger('click');
            }
        })
        // Turn on memory
        for (var legend in legendSearchMemory) {
            if ($('#' + legend).is(':checked') != legendSearchMemory[legend]) {
                $('#' + legend).trigger('click');
            }
        }
        legendSearchMemory = {};
    }
}

function showLocationInfo() {

    if (location === null && !isDevEnvironment()) return;

    featureListCacheMapObjects['boligsoner'] = [];
    featureListCacheMapObjects['boligsoner'].push(map.data.addGeoJson(featureListCache['boligsoner'][0]));
    featureListCacheMapObjects['boligsoner'].push(map.data.addGeoJson(featureListCache['boligsoner'][1]));

    var zone = getInZone(featureListCacheMapObjects['boligsoner']);
    var closestParkingHouse = findClosestParkingHouse();

    if (zone!=null || closestParkingHouse!=null) {
        var html = [];
        var text = [];

        if (zone!=null) {

            text.push(trans('Du er i') + ' ' + zone);
            html.push(trans('Du er i') + " <a href='#' onclick='showZone(\"" + zone + "\");'>" + zone + "</a>");
        }
        if (closestParkingHouse != null) {
            text.push(trans('Nærmeste parkeringshus er') + ' ' + closestParkingHouse);
            html.push(trans('Nærmeste parkeringshus er') + " <a href='#' onclick='showMarker(\"" + closestParkingHouse + "\");'>" + closestParkingHouse + '</a>');
        }

        var message = text.join('. ') + '.';

        if (getCookieValue('map-info') !== message) {
            $('#map-info .content').html('<p>' + html.join(". ") + '.</p>');
            $('#map-info').css({display: 'inline-block'});
            document.cookie = 'map-info=; expires=' + (new Date().getDate() - 1) + '; path=/';
        }
    }


    function getInZone(list) {
        if (isDevEnvironment()) {
            return 'Sone 1';
        }

        let position = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);         // Iterate geojson
        for (var i = 0; i < list.length; i++) {
            // Iterate features
            for (var f = 0; f < list[i].length; f++) {
                // If not polygon, discard
                if (list[i][f].getGeometry().getType() === 'Polygon') {
                    var polyPath = list[i][f].getGeometry().getAt(0).getArray();
                    var poly = new google.maps.Polygon({
                        paths: polyPath
                    });

                    if (google.maps.geometry.poly.containsLocation(position, poly)) {
                        var title = list[i][f].getProperty('Name');
                        return title;
                    }
                }
            }
        }
        return null;
    }

    function findClosestParkingHouse() {
        if (location === null) return;

        var closestLen = Number.MAX_SAFE_INTEGER;
        var closest = null;
        var loc = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);

        if (!markers['phus']) {
            return null;
        }

        markers['phus'].forEach(function(marker) {
            if (marker.mapInfo.count===0) return;
            let len = google.maps.geometry.spherical.computeDistanceBetween (loc, marker.getPosition());
            if (len<closestLen) {
                closestLen = len;
                closest = marker;
            }
        })
        if (closest===null) return null;
        return closest.mapInfo.title;
    }

    removeCacheFeatures();
}

function showLocationMarker() {
    if (!location) {
        return;
    }

    var position = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);

    var url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.locationMarkerIcon);

    var icon = {
        url: url,
        scaledSize: new google.maps.Size(20, 20), // scaled size
        optimized: false,
        //anchor: anchor
    };

    if (currentLocationMarker) {
        currentLocationMarker.setPosition(position);
    } else {
        currentLocationMarker = new google.maps.Marker({
            position: position,
            map: map,
            icon: icon ? icon : null
        });
    }
}

function showMarker(title) {
    $('#map-phus').prop('checked', true).trigger('change');
    var marker = getParkingHouseMarker(title);

    if (!marker) {
        return;
    }

    google.maps.event.trigger(marker, 'click');
}

function showZone(title) {
    var feature = getZoneFeature(title);
    if (!feature) {
        return;
    }

    var polyPath = feature.getGeometry().getAt(0).getArray();
    var poly = new google.maps.Polygon({
        paths: polyPath
    });

    var bounds = new google.maps.LatLngBounds()
    poly.getPaths().forEach(function(path) {
        path.forEach(function(point) {
            bounds.extend(point);
        });
    });

    $('#map-boligsoner').prop('checked', true).trigger('change');
    showFeature(feature, bounds.getCenter());
}

function getParkingHouseMarker(title) {
    var m = null;
    markers['phus'].forEach(function(marker) {
        if (marker.mapInfo.count===0) return;
        if (marker.mapInfo.title === title) {
            m = marker;
        }
    });

    return m;
}

function getZoneFeature(title) {
    var list = featureListCacheMapObjects['boligsoner'];

    for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].length;  j++) {
            var feature = list[i][j];
            if (feature.getProperty('Name') === title) {
                return list[i][j];
            }
        }
    }

    return null;
}

function setupMapMode() {
    var $legend = $('#legend');

    $('#map-mode-map').click(function () {
        $(this).addClass('active');
        $('#map-mode-satellite').removeClass('active');
        map.setMapTypeId('roadmap');
    });
    $('#map-mode-satellite').click(function () {
        $(this).addClass('active');
        $('#map-mode-map').removeClass('active');
        map.setMapTypeId('satellite');
    });
    $('#map-mode-zoom-in').click(function() {
        map.setZoom(map.getZoom()+1);
    });
    $('#map-mode-zoom-out').click(function() {
        map.setZoom(map.getZoom()-1);
    });
    $('#map-mode-zoom-in-button').click(function() {
        map.setZoom(map.getZoom()+1);
    });
    $('#map-mode-zoom-out-button').click(function() {
        map.setZoom(map.getZoom()-1);
    });
    $('#map-mode-fullscreen').click(function() {
        requestFullscreen(map.getDiv().firstChild);
    });
    $('#map-legend-hide-button').click(function() {
        $(this).hide();
        $legend.animate({
           marginLeft: "-300px"
        }, 200, function() {
            // Finished hiding, showing show button
            $legend.css('display', 'none');
            $('#map-legend-show').css('display', 'block');

            $('#map-legend-show').animate({
                marginLeft: "0em"
            }, 200, function() {
                
            })
        });
    });
    $('#map-legend-show').click(function() {
        $(this).animate({
            marginLeft: "-300px"
        }, 200, function() {
            $('#map-legend-show').hide();
            $('#map-legend-hide-button').show();
            $legend.css('display', 'block');

            //$legend.css('display', 'block');
            $legend.animate({
                marginLeft: ""
            }, 200, function() {
                $legend.removeAttr('style');
            })
        })
    })

    if (isMapEmbed) {
        $('#legend').css({marginLeft: '-300px', display: 'none'});
        $('#map-legend-show').css({marginLeft: 0, display: 'block'});
    }

    var $mapModeFullscreenOff = $('#map-mode-fullscreen-off');
    $mapModeFullscreenOff.click(exitFullscreen);

    map.controls[google.maps.ControlPosition.RIGHT_TOP].push($mapModeFullscreenOff[0]);

    var onfullscreenChange = function() {
        if (isFullscreen(map.getDiv().firstChild)) {
            $mapModeFullscreenOff.show();
        } else {
            $mapModeFullscreenOff.hide();
        }
    };

    document.onwebkitfullscreenchange = onfullscreenChange;
    document.onmsfullscreenchange = onfullscreenChange;
    document.onmozfullscreenchange = onfullscreenChange;
    document.onfullscreenchange = onfullscreenChange;

    function isFullscreen(element) {
        return (document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement) == element;
    }

    function requestFullscreen(element) {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullScreen) {
            element.msRequestFullScreen();
        }
    }

    function exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msCancelFullScreen) {
            document.msCancelFullScreen();
        }
    }
}

function addParkingHouses() {
    let type = 'phus';
    if (!(type in markers)) {
        markers[type] = [];
    }

    dataCache[type].forEach(function (poi) {
        var point = {lat: poi.lat, lng: poi.lng};

        var count = ' ';
        var name = poi.navn;
        if (searchFilter === '' || name.toUpperCase().includes(searchFilter)) {
            if (name in availableParking) {
                count = availableParking[name];
            }

            var marker = new google.maps.Marker({
                position: point,
                map: map,
                icon: pinShadow(count),
                mapInfo: {
                    title: name,
                    count: count
                }
            });

            markers[type].push(marker);
        }
    });

    dataCache[type].forEach(function (poi) {
        var point = {lat: poi.lat, lng: poi.lng};

        var count = ' ';
        var name = poi.navn;
        if (searchFilter === '' || name.toUpperCase().includes(searchFilter)) {
            // Different names in live data than in actual name for parking house
            if (name in liveDataNameConversion) {
                name = liveDataNameConversion[name];
            }
            if (name in availableParking) {
                count = availableParking[name];
            }

            var isNumber = count === '0' || !isNaN(parseInt(count))

            var marker = new google.maps.Marker({
                position: point,
                map: map,
                label: {
                    text: isNumber ? '' + count : ' ',
                    color: getPinLabelColor(count),
                    fontFamily: 'Montserrat, sans-serif',
                    fontWeight: 'bold',
                    fontSize: '10px'
                },
                icon: pinSymbol(count),
                mapInfo: {
                    title: name,
                    count: count
                }, 
                title: 'Kart markør'
            });

            var isNumber = count === '0' || !isNaN(parseInt(count));
            var description = isNumber ? '<p>' + count + ' ' + trans('ledige plasser') + '</p>' : '';

            var links = ['<a href="https://www.google.com/maps/dir/?api=1&destination=' + point.lat + ',' + point.lng + '" target="_blank">' + trans('Få veibeskrivelse') + '</a>'];

            var name = poi.navn ? locationDataNameConversion[poi.navn] : null;
            if (name) {
                if(language === 'en') {
                    links.push('<a href="/en/parkering/p-hus/#' + slugify(name) + '">' + trans('Mer info') + '</a>');
                } else {
                    links.push('<a href="/parkering/p-hus/#' + slugify(name) + '">' + trans('Mer info') + '</a>');
                }
            }

            description += '<p>' + links.join(' | ') + '</p>';

            setupMarkerInfoWindows(marker, poi.navn, description);
            markers[type].push(marker);
        }
    })

    doZoomIncludeAll();
}

function getPinLabelColor(count) {
    return 'black';
}

function setupInfoWindow() {
    infowindow = new google.maps.InfoWindow();

    map.data.addListener('click', function (event) {
        showFeature(event.feature, event.latLng);
    });
}

function showFeature(feature, center) {
    var title = feature.getProperty('Name');
    var description = ''
    if(language === 'en' && feature.getProperty('description-en')) {
        description = feature.getProperty("description-en");
    } else {
        description = feature.getProperty("description");
    }
    var content = '<div class="info-window">' +
        '<h4>' + title + '</h4>' +
        '<div class="info">' + description + '</div>' +
        '</div>';

    infowindow.setContent(content);
    infowindow.setPosition(center);
    infowindow.setOptions({pixelOffset: new google.maps.Size(0, 0)});
    infowindow.open(map);
}

function setupMarkerInfoWindows(marker, title, description) {
    marker.addListener('click', function () {
        var content = '<div class="info-window">' +
            '<h4>' + title + '</h4>' +
            '<div class="info">' + description + '</div>' +
            '</div>';

        infowindow.setContent(content);
        infowindow.setPosition(event.latLng);
        infowindow.setOptions({pixelOffset: new google.maps.Size(0, -10)});
        infowindow.open(map, marker);
    })
}

function setupZoneColors() {
    map.data.setStyle(function (feature) {
        var name = feature.getProperty('Name');
        var color = 'rgba(76,105,46,0.7)';
        if (name in areaColors) {
            color = areaColors[name];
        }
        var opacity = 0;
        if (feature.getProperty('opacity') === 1) {
            opacity = 1;
        }
        return {
            fillOpacity: opacity,
            strokeOpacity: opacity,
            fillColor: color,
            strokeWeight: 1
        }
    });

}

function setupBoligSoner() {
    $('#map-boligsoner').change(function () {
        if ($(this).is(':checked')) {
            removeFeature('boligsoner');
            loadGeoJson("boligsoner");
            doZoomIncludeAll();
        } else {
            removeFeature('boligsoner');
            doZoomIncludeAll();
        }
    })
}

function setupPiggdekkAvgift() {
    $('#map-piggdekkavgift').click(function () {
        if ($(this).is(':checked')) {
            loadGeoJson("stavanger");
            doZoomIncludeAll();

        } else {
            removeFeature('stavanger');
            doZoomIncludeAll();
        }
    })
}

function removeFeature(type) {
    if (!(type in featureList)) {
        return;
    }
    featureList[type].forEach(function (features) {
        for (var i = 0; i < features.length; i++)
            map.data.remove(features[i]);
    });
    delete featureList[type];
    infowindow.close();
}

function removeCacheFeatures() {
    for (var i = 0; i < featureListCacheMapObjects['boligsoner'].length; i++) {
        for (var j = 0; j < featureListCacheMapObjects['boligsoner'][i].length; j++) {
            map.data.remove(featureListCacheMapObjects['boligsoner'][i][j]);
        }
    }
}

function loadGeoJson(type) {
    featureListCache[type].forEach(function (featureLocalList) {
        var features = {
            "type": "FeatureCollection",
            "name": "Informasjonslag uten navn",
            "crs": {
                "type": "name",
                "properties": {
                    "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
                }
            },
            "features": []
        };
        featureLocalList['features'].forEach(function (feature) {
            if (searchFilter === '' ||
                (('properties' in feature) && ('Name' in feature['properties']) && feature['properties']['Name'].toUpperCase().includes(searchFilter)) ||
                (('properties' in feature) && ('description' in feature['properties']) && typeof feature['properties']['description'] === 'string' && feature['properties']['description'].toUpperCase().includes(searchFilter))) {
                var newFeature = JSON.parse(JSON.stringify(feature));
                newFeature.properties['opacity'] = 1;

                if (type === 'boligsoner') {
                    if(language === 'en' && newFeature.properties['description-en']) {
                        newFeature.properties['description-en'] = newFeature.properties['description-en'] + '<br><br><a href="/en/tillatelser/boligsoneparkering/">' + trans('Les mer') + '</a>';
                    } else {
                        newFeature.properties['description'] = newFeature.properties['description'] + '<br><br><a href="' + (language === 'en' ? '/en' : '') + '/tillatelser/boligsoneparkering/">' + trans('Les mer') + '</a>';
                    }
                }

                features['features'].push(newFeature);
            }
        })
        var mapFeatures = map.data.addGeoJson(features);

        if (!(type in featureList)) {
            featureList[type] = [];
        }
        featureList[type].push(mapFeatures);
    });
}

function addClickOnCheckboxes(id, type) {
    $('#' + id).change(function () {
        if ($(this).is(':checked')) {
            if (type in markers) {
                return;
            }

            if (type === 'phus') {
                addParkingHouses();
            } else {
                addType(type);
            }
        } else {
            removeType(type);
        }
    })
}

function removeStyles() {
    var styles = [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#959ea6"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f3f1e9"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#c0cd7d"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#959ea6"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#f0eee1"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
                {
                    "color": "#959ea6"
                }
            ]
        }
    ];

    map.setOptions({styles: styles});
}

function addType(type) {
    if (!(type in markers)) {
        markers[type] = [];
    }

    // Shadows (added first to have the lowest z position)
    dataCache[type].forEach(function (poi) {
        if (searchFilter === '' || poi.navn.toUpperCase().includes(searchFilter)) {
            var point = {lat: poi.lat, lng: poi.lng};

            var scaledSize = new google.maps.Size(50, 50);

            var url = null;
            var anchor = null;
            
            switch (type) {
                case 'hc':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.hcIconShadow);
                    scaledSize = new google.maps.Size(50, 30);
                    anchor = new google.maps.Point(50, 25);
                    break;
            }

            if (url) {
                var icon = {
                    url: url,
                    scaledSize: scaledSize, // scaled size
                    optimized: false,
                    anchor: anchor
                };

                var marker = new google.maps.Marker({
                    position: point,
                    map: map,
                    icon: icon ? icon : null
                });

                markers[type].push(marker);
            }
        }
    })

    // Regular markers
    dataCache[type].forEach(function (poi) {
        if (searchFilter === '' || poi.navn.toUpperCase().includes(searchFilter)) {
            var point = {lat: poi.lat, lng: poi.lng};

            var scaledSize = new google.maps.Size(50, 50);

            var url = null;
            var anchor = null;
            
            switch (type) {
                case 'el-phus':
                case 'el-gateplan':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.chargingIcon);
                    scaledSize = new google.maps.Size(91.7, 50);
                    break;
                case 'hc':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.hcIcon);
                    scaledSize = new google.maps.Size(29.67, 50);
                    break;
                case 'buss':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.busIcon);
                    scaledSize = new google.maps.Size(50, 50);
                    break;
                case 'mc':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.mcIcon);
                    scaledSize = new google.maps.Size(50, 50);
                    break;
                case 'Sykkelparkering':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.bikeIcon);
                    scaledSize = new google.maps.Size(50, 50);
                    break;
                case 'pautomater':
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.parkingMeterIcon);
                    scaledSize = new google.maps.Size(80, 45);
                    break;
                case "bobil" :
                    url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(mapIcons.camperMarkerIcon);
                    scaledSize = new google.maps.Size(80, 45);
                    break;
            }

            var icon = {
                url: url,
                scaledSize: scaledSize, // scaled size
                optimized: false,
                anchor: anchor
            };

            var marker = new google.maps.Marker({
                position: point,
                map: map,
                icon: icon ? icon : null
            });

            markers[type].push(marker);

            var comment = language === 'en' ? poi['comment'] : poi['kommentar'];

            if (poi.navn || comment) {
                setupMarkerInfoWindows(marker, poi.navn || '', comment || '');
            }
        }
    })
    doZoomIncludeAll();
}

function removeType(type) {
    if (!(type in markers)) {
        return;
    }
    markers[type].forEach(function (marker) {
        marker.setMap(null);
    });
    delete markers[type];
    doZoomIncludeAll();
}

function pinSymbol(count) {
    var greenPin = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38 60" style="enable-background:new 0 0 38 60;" xml:space="preserve"><style type="text/css"> .st0{fill:#669046;} .st1{fill:#a3b952;} </style><path class="st0" d="M4.8,21.7c0-0.4,0.1-0.9,0.2-1.3c0-0.1,0-0.2,0-0.3c0.1-0.4,0.2-0.9,0.3-1.3l0,0c0.1-0.4,0.2-0.9,0.4-1.3 c0-0.1,0-0.2,0.1-0.2c0.1-0.4,0.3-0.8,0.4-1.3c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.3-0.8,0.5-1.3l0,0c0.2-0.3,0.3-0.7,0.5-1 c0-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.3-0.6,0.5-0.9l0.1-0.1c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.7 c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.4-0.5,0.6-0.8l0,0c0.2-0.3,0.5-0.5,0.7-0.8C11,8.4,11,8.4,11.1,8.3c0.2-0.2,0.5-0.4,0.7-0.7 c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.5,0.9-0.7C13,6.7,13,6.6,13.1,6.6c0.4-0.3,0.8-0.6,1.1-0.8c0,0,0.1,0,0.1-0.1 c0.4-0.3,0.8-0.5,1.2-0.7c0,0,0.1,0,0.1-0.1c0.4-0.2,0.8-0.4,1.2-0.6c0.1,0,0.1-0.1,0.2-0.1c0.4-0.2,0.8-0.3,1.2-0.5 c0.1,0,0.1-0.1,0.2-0.1c0.4-0.1,0.8-0.3,1.3-0.4c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.2,1.4-0.3c0.4-0.1,0.8-0.1,1.2-0.1 c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.8,0c0.1,0,0.3,0,0.4,0c0.2,0,0.5,0,0.7,0s0.3,0,0.5,0.1c0.2,0,0.4,0.1,0.6,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.1,0.9,0.2c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.4C29,3.9,29.3,4,29.6,4.2l-4.5-2.3 c-0.3-0.1-0.5-0.3-0.8-0.4l0,0c-0.4-0.2-0.8-0.3-1.2-0.4C23,1.1,22.9,1,22.8,1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5,0-0.8,0 c-0.1,0-0.3,0-0.4,0c-0.4,0-0.8,0.1-1.2,0.1c-0.5,0.1-0.9,0.2-1.4,0.3c-0.1,0-0.1,0-0.2,0C14.9,1,14.4,1.1,14,1.3 c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.8,0.3-1.2,0.5c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.2-0.8,0.4-1.2,0.6l0,0c0,0,0,0-0.1,0 c-0.4,0.2-0.8,0.5-1.2,0.7c0,0-0.1,0-0.1,0.1C9.4,3.7,9,3.9,8.7,4.2c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0.1C8.2,4.6,7.9,4.9,7.6,5.1 c-0.1,0-0.1,0.1-0.2,0.1C7.2,5.4,6.9,5.6,6.7,5.9L6.6,6L6.5,6.1C6.2,6.4,6,6.6,5.8,6.9l0,0C5.6,7.2,5.4,7.4,5.1,7.7L5,7.8 c0,0-0.1,0.1-0.1,0.2C4.7,8.2,4.6,8.4,4.4,8.7C4.3,8.8,4.3,8.9,4.2,8.9C4,9.2,3.8,9.5,3.6,9.8l0,0c0,0,0,0.1-0.1,0.1 c-0.2,0.3-0.3,0.6-0.5,0.9c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.3,0.7-0.5,1l0,0l0,0c-0.2,0.4-0.4,0.8-0.5,1.3 c0,0.1-0.1,0.2-0.1,0.2c-0.2,0.4-0.3,0.8-0.4,1.3V15v0.1C1.2,15.5,1,16,0.9,16.4l0,0c-0.1,0.4-0.2,0.9-0.3,1.3c0,0.1,0,0.2,0,0.2 c-0.1,0.4-0.1,0.9-0.2,1.3c0,0.1,0,0.2,0,0.3c0,0.5-0.1,0.9-0.1,1.4c0,2.1,0.7,5,1.8,8.2c4.2,11.7,13.5,27,14,27.8l4.5,2.3 c-0.5-0.8-9.9-16.1-14-27.8c-1.1-3.2-1.9-6.1-1.8-8.2c0-0.5,0-0.9,0.1-1.4C4.8,21.8,4.8,21.7,4.8,21.7z"/><g><path class="st1" d="M21.3,3c9-1.3,16.2,5.8,16.1,15.7c0,2.1-0.8,5.2-2,8.8c-4.5,12.9-14.2,30.9-14.7,31.9 c-0.5-0.8-9.9-16.1-14-27.8c-1.1-3.2-1.9-6.1-1.8-8.2C4.9,13.4,12.3,4.3,21.3,3z"/></g></svg>';
    var redPin = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38 60" style="enable-background:new 0 0 38 60;" xml:space="preserve"><style type="text/css"> .st0{fill:#BE5C58;} .st1{fill:#DD766F;} </style><path class="st0" d="M4.8,21.7c0-0.4,0.1-0.9,0.2-1.3c0-0.1,0-0.2,0-0.3c0.1-0.4,0.2-0.9,0.3-1.3l0,0c0.1-0.4,0.2-0.9,0.4-1.3 c0-0.1,0-0.2,0.1-0.2c0.1-0.4,0.3-0.8,0.4-1.3c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.3-0.8,0.5-1.3l0,0c0.2-0.3,0.3-0.7,0.5-1 c0-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.3-0.6,0.5-0.9l0.1-0.1c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.7 c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.4-0.5,0.6-0.8l0,0c0.2-0.3,0.5-0.5,0.7-0.8C11,8.4,11,8.4,11.1,8.3c0.2-0.2,0.5-0.4,0.7-0.7 c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.5,0.9-0.7C13,6.7,13,6.6,13.1,6.6c0.4-0.3,0.8-0.6,1.1-0.8c0,0,0.1,0,0.1-0.1 c0.4-0.3,0.8-0.5,1.2-0.7c0,0,0.1,0,0.1-0.1c0.4-0.2,0.8-0.4,1.2-0.6c0.1,0,0.1-0.1,0.2-0.1c0.4-0.2,0.8-0.3,1.2-0.5 c0.1,0,0.1-0.1,0.2-0.1c0.4-0.1,0.8-0.3,1.3-0.4c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.2,1.4-0.3c0.4-0.1,0.8-0.1,1.2-0.1 c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.8,0c0.1,0,0.3,0,0.4,0c0.2,0,0.5,0,0.7,0s0.3,0,0.5,0.1c0.2,0,0.4,0.1,0.6,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.1,0.9,0.2c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.4C29,3.9,29.3,4,29.6,4.2l-4.5-2.3 c-0.3-0.1-0.5-0.3-0.8-0.4l0,0c-0.4-0.2-0.8-0.3-1.2-0.4C23,1.1,22.9,1,22.8,1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5,0-0.8,0 c-0.1,0-0.3,0-0.4,0c-0.4,0-0.8,0.1-1.2,0.1c-0.5,0.1-0.9,0.2-1.4,0.3c-0.1,0-0.1,0-0.2,0C14.9,1,14.4,1.1,14,1.3 c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.8,0.3-1.2,0.5c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.2-0.8,0.4-1.2,0.6l0,0c0,0,0,0-0.1,0 c-0.4,0.2-0.8,0.5-1.2,0.7c0,0-0.1,0-0.1,0.1C9.4,3.7,9,3.9,8.7,4.2c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0.1C8.2,4.6,7.9,4.9,7.6,5.1 c-0.1,0-0.1,0.1-0.2,0.1C7.2,5.4,6.9,5.6,6.7,5.9L6.6,6L6.5,6.1C6.2,6.4,6,6.6,5.8,6.9l0,0C5.6,7.2,5.4,7.4,5.1,7.7L5,7.8 c0,0-0.1,0.1-0.1,0.2C4.7,8.2,4.6,8.4,4.4,8.7C4.3,8.8,4.3,8.9,4.2,8.9C4,9.2,3.8,9.5,3.6,9.8l0,0c0,0,0,0.1-0.1,0.1 c-0.2,0.3-0.3,0.6-0.5,0.9c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.3,0.7-0.5,1l0,0l0,0c-0.2,0.4-0.4,0.8-0.5,1.3 c0,0.1-0.1,0.2-0.1,0.2c-0.2,0.4-0.3,0.8-0.4,1.3V15v0.1C1.2,15.5,1,16,0.9,16.4l0,0c-0.1,0.4-0.2,0.9-0.3,1.3c0,0.1,0,0.2,0,0.2 c-0.1,0.4-0.1,0.9-0.2,1.3c0,0.1,0,0.2,0,0.3c0,0.5-0.1,0.9-0.1,1.4c0,2.1,0.7,5,1.8,8.2c4.2,11.7,13.5,27,14,27.8l4.5,2.3 c-0.5-0.8-9.9-16.1-14-27.8c-1.1-3.2-1.9-6.1-1.8-8.2c0-0.5,0-0.9,0.1-1.4C4.8,21.8,4.8,21.7,4.8,21.7z"/><g><path class="st1" d="M21.3,3c9-1.3,16.2,5.8,16.1,15.7c0,2.1-0.8,5.2-2,8.8c-4.5,12.9-14.2,30.9-14.7,31.9 c-0.5-0.8-9.9-16.1-14-27.8c-1.1-3.2-1.9-6.1-1.8-8.2C4.9,13.4,12.3,4.3,21.3,3z"/></g></svg>';
    var bluePin = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38 60" style="enable-background:new 0 0 38 60;" xml:space="preserve"><style type="text/css"> .st0{fill:#2D8197;} .st1{fill:#49A3BF;} </style><path class="st0" d="M4.8,21.7c0-0.4,0.1-0.9,0.2-1.3c0-0.1,0-0.2,0-0.3c0.1-0.4,0.2-0.9,0.3-1.3l0,0c0.1-0.4,0.2-0.9,0.4-1.3 c0-0.1,0-0.2,0.1-0.2c0.1-0.4,0.3-0.8,0.4-1.3c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.3-0.8,0.5-1.3l0,0c0.2-0.3,0.3-0.7,0.5-1 c0-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.3-0.6,0.5-0.9l0.1-0.1c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.7 c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.4-0.5,0.6-0.8l0,0c0.2-0.3,0.5-0.5,0.7-0.8C11,8.4,11,8.4,11.1,8.3c0.2-0.2,0.5-0.4,0.7-0.7 c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.5,0.9-0.7C13,6.7,13,6.6,13.1,6.6c0.4-0.3,0.8-0.6,1.1-0.8c0,0,0.1,0,0.1-0.1 c0.4-0.3,0.8-0.5,1.2-0.7c0,0,0.1,0,0.1-0.1c0.4-0.2,0.8-0.4,1.2-0.6c0.1,0,0.1-0.1,0.2-0.1c0.4-0.2,0.8-0.3,1.2-0.5 c0.1,0,0.1-0.1,0.2-0.1c0.4-0.1,0.8-0.3,1.3-0.4c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.2,1.4-0.3c0.4-0.1,0.8-0.1,1.2-0.1 c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.8,0c0.1,0,0.3,0,0.4,0c0.2,0,0.5,0,0.7,0s0.3,0,0.5,0.1c0.2,0,0.4,0.1,0.6,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.1,0.9,0.2c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.4C29,3.9,29.3,4,29.6,4.2l-4.5-2.3 c-0.3-0.1-0.5-0.3-0.8-0.4l0,0c-0.4-0.2-0.8-0.3-1.2-0.4C23,1.1,22.9,1,22.8,1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5,0-0.8,0 c-0.1,0-0.3,0-0.4,0c-0.4,0-0.8,0.1-1.2,0.1c-0.5,0.1-0.9,0.2-1.4,0.3c-0.1,0-0.1,0-0.2,0C14.9,1,14.4,1.1,14,1.3 c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.8,0.3-1.2,0.5c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.2-0.8,0.4-1.2,0.6l0,0c0,0,0,0-0.1,0 c-0.4,0.2-0.8,0.5-1.2,0.7c0,0-0.1,0-0.1,0.1C9.4,3.7,9,3.9,8.7,4.2c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0.1C8.2,4.6,7.9,4.9,7.6,5.1 c-0.1,0-0.1,0.1-0.2,0.1C7.2,5.4,6.9,5.6,6.7,5.9L6.6,6L6.5,6.1C6.2,6.4,6,6.6,5.8,6.9l0,0C5.6,7.2,5.4,7.4,5.1,7.7L5,7.8 c0,0-0.1,0.1-0.1,0.2C4.7,8.2,4.6,8.4,4.4,8.7C4.3,8.8,4.3,8.9,4.2,8.9C4,9.2,3.8,9.5,3.6,9.8l0,0c0,0,0,0.1-0.1,0.1 c-0.2,0.3-0.3,0.6-0.5,0.9c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.3,0.7-0.5,1l0,0l0,0c-0.2,0.4-0.4,0.8-0.5,1.3 c0,0.1-0.1,0.2-0.1,0.2c-0.2,0.4-0.3,0.8-0.4,1.3V15v0.1C1.2,15.5,1,16,0.9,16.4l0,0c-0.1,0.4-0.2,0.9-0.3,1.3c0,0.1,0,0.2,0,0.2 c-0.1,0.4-0.1,0.9-0.2,1.3c0,0.1,0,0.2,0,0.3c0,0.5-0.1,0.9-0.1,1.4c0,2.1,0.7,5,1.8,8.2c4.2,11.7,13.5,27,14,27.8l4.5,2.3 c-0.5-0.8-9.9-16.1-14-27.8c-1.1-3.2-1.9-6.1-1.8-8.2c0-0.5,0-0.9,0.1-1.4C4.8,21.8,4.8,21.7,4.8,21.7z"/><g><path class="st1" d="M21.3,3c9-1.3,16.2,5.8,16.1,15.7c0,2.1-0.8,5.2-2,8.8c-4.5,12.9-14.2,30.9-14.7,31.9 c-0.5-0.8-9.9-16.1-14-27.8c-1.1-3.2-1.9-6.1-1.8-8.2C4.9,13.4,12.3,4.3,21.3,3z"/></g></svg>';

    var url = null;

    if (isNaN(parseInt(count))) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(bluePin);
    } else if (count < 10) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redPin);
    } else if (count < 100) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(bluePin);
    } else {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(greenPin);
    }

    return {
        url: url,
        scaledSize: new google.maps.Size(32, 50),
        optimized: false,
        labelOrigin: new google.maps.Point(17.2, 20)
    };
}

function pinShadow(count) {
    var greenPinShadow = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.3 32.3" style="enable-background:new 0 0 55.3 32.3;" xml:space="preserve"><style type="text/css"> .st0{opacity:0.2;} .st1{fill:#7A964D;} </style><g class="st0"><path class="st1" d="M5,2.4C4.5,2.7,3.9,3,3.5,3.4C-2.7,8.1-0.2,16,8.9,21c1.9,1.1,5.2,2.2,9.1,3.3c14.2,4,36,7.7,37.1,7.9 c-0.5-0.7-9.3-14.1-17.7-22.7C35.2,7.2,33,5.3,31,4.2C22.6-0.4,11.5-1.1,5,2.4"/></g></svg>';
    var redPinShadow = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.3 32.3" style="enable-background:new 0 0 55.3 32.3;" xml:space="preserve"><style type="text/css"> .st0{opacity:0.2;} .st1{fill:#BE5C58;} </style><g class="st0"><path class="st1" d="M5,2.4C4.5,2.7,3.9,3,3.5,3.4C-2.7,8.1-0.2,16,8.9,21c1.9,1.1,5.2,2.2,9.1,3.3c14.2,4,36,7.7,37.1,7.9 c-0.5-0.7-9.3-14.1-17.7-22.7C35.2,7.2,33,5.3,31,4.2C22.6-0.4,11.5-1.1,5,2.4"/></g></svg>';
    var bluePinShadow = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.3 32.3" style="enable-background:new 0 0 55.3 32.3;" xml:space="preserve"><style type="text/css"> .st0{opacity:0.2;} .st1{fill:#3895B6;} </style><g class="st0"><path class="st1" d="M5,2.4C4.5,2.7,3.9,3,3.5,3.4C-2.7,8.1-0.2,16,8.9,21c1.9,1.1,5.2,2.2,9.1,3.3c14.2,4,36,7.7,37.1,7.9 c-0.5-0.7-9.3-14.1-17.7-22.7C35.2,7.2,33,5.3,31,4.2C22.6-0.4,11.5-1.1,5,2.4"/></g></svg>';

    var url = null;

    if (isNaN(parseInt(count))) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(bluePinShadow);
    } else if (count < 10) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redPinShadow);
    } else if (count < 100) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(bluePinShadow);
    } else {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(greenPinShadow);
    }

    return {
        url: url,
        scaledSize: new google.maps.Size(50, 29),
        optimized: false,
        anchor: new google.maps.Point(50, 29)
    };
}

function doZoomIncludeAll() {
    var count = 0;
    var bounds = new google.maps.LatLngBounds();
    $.each(markers, function (type, list) {
        for (var i = 0; i < list.length; i++) {
            bounds.extend(list[i].getPosition());
            count++;
        }
    });
    $.each(featureList, function (type, list) {
        // Iterate geojson
        for (var i = 0; i < list.length; i++) {
            // Iterate features
            for (var f = 0; f < list[i].length; f++) {
                // If not polygon, discard
                if (list[i][f].getGeometry().getType() === 'Polygon') {
                    list[i][f].getGeometry().getArray().forEach(function (path) {

                        //iterate over the points in the path
                        path.getArray().forEach(function (latLng) {
                            //extend the bounds
                            bounds.extend(latLng);
                            count++;
                        });
                    });
                }
            }
        }
    })
    if (count > 0) {
        var latTreshold = 0.02;
        var lngTreshold = 0.04;
        var diffLat = Math.abs(bounds.getSouthWest().lat() - bounds.getNorthEast().lat());
        var diffLng = Math.abs(bounds.getSouthWest().lng() - bounds.getNorthEast().lng());

    if (!featureList['stavanger'] && !$('#map-bobil').is(':checked') && (diffLng > lngTreshold || diffLat > latTreshold)) {
            map.setCenter(stavangerCoords);
            map.setZoom(defaultZoom);
        } else {
            let padding = window.innerWidth < 300 ? 0 : 100;
            map.fitBounds(bounds, {bottom: padding, top: padding, right: padding, left: padding});
        }
    }
}

function getLocation() {
    if (isDevEnvironment()) {
        var location1 = {
            coords: {
                latitude: stavangerCoords.lat,
                longitude: stavangerCoords.lng
            }
        };

        var location2 = {
            coords: {
                latitude: 58.966427,
                longitude: 5.73302
            }
        };


        showPosition(location1);

        setInterval(function() {
            if (location.coords.latitude === location1.coords.latitude) {
                showPosition(location2);
            } else {
                showPosition(location1);
            }
        }, 8000);
    }

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
        navigator.geolocation.watchPosition(showPosition);
    } else {
        console.log("Geolocation not supported");
    }
}

function showPosition(position) {
    location = position;
    showLocationInfo();
    showLocationMarker();
}

function slugify(slug) {
 return slug.toLowerCase().replace('.', '').replace(' ', '-');
}

function getQueryParameter(key) {
    var results = new RegExp('[\?&]' + key + '=([^&#]*)')
        .exec(window.location.search);

    return (results !== null) ? results[1] || 0 : false;
}

function isDevEnvironment() {
    return window.location.hostname === 'stavanger-parkering.local';
}

function trans(string) {
    if (language === 'en') {
        return translations[string] || string;
    }

    return string;
}

function getCookieValue(a) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

window.showMarker = showMarker;
window.showZone = showZone;
